import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
// import axios from "axios";

export default function ApiSingleAutocomplete({
    value,
    onChange,
    label = "Select item",
    endpoint = "",
}) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    // predefined label builder
    const buildLabel = (item) => {
        if (!item) return "";
        return `${item.firstname} ${item.lastname} (${item.email})`;
    };

    useEffect(() => {
        let active = true;

        const loadData = async () => {
            try {
                setLoading(true);
                const response = null; // TODO: implement API call, maybe with axios or fetch
                // const response = await axios.get(endpoint);

                if (!active) return;

                // assuming response.data is an array
                setOptions(Array.isArray(response.data) ? response.data : []);
            } catch (error) {
                console.error("Failed to load autocomplete data:", error);
                if (active) setOptions([]);
            } finally {
                if (active) setLoading(false);
            }
        };

        loadData();

        return () => {
            active = false;
        };
    }, []);
    if (endpoint == null || endpoint === "") {
        return null;
    }
    return (
        <Autocomplete
            options={options}
            loading={loading}
            value={value}
            onChange={(event, newValue) => {
                onChange?.(newValue);
            }}
            getOptionLabel={(option) => buildLabel(option)}
            isOptionEqualToValue={(option, selectedValue) =>
                option.id === selectedValue?.id
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}